import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import HeaderFooter from "../components/headerFooter";
import ButtonBlue from "../../../shared/buttonBlue";
require("dayjs/locale/th");
dayjs.locale("th");

const baseColumns = (dateTimeLabel) => [
  { id: "requester", label: "ผู้จอง", align: "center", width: "240px" },
  {
    id: "dateTimeStart",
    label: dateTimeLabel,
    align: "center",
    width: "140px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "240px" },
  { id: "status", label: "สถานะ", align: "center", width: "140px" },
];

const columnsByStatus = {
  รอการจัดหาคนขับรถ: baseColumns("วัน-เวลา ที่จอง"),
  กำลังดำเนินการ: baseColumns("วัน-เวลา ที่รับผู้โดยสาร"),
  รายการเสร็จสิ้น: baseColumns("วัน-เวลา ที่ส่งผู้โดยสาร"),
};

const BetweenSiteCar = (props) => {
  const [listBookingWaitingForDriver, setListBookingWaitingForDriver] =
    useState([]);
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  const statusOptions = [
    {
      status: "Waiting",
      label: "รอการจัดหาคนขับรถ",
      color: "#F44336",
      hoverColor: "#d9392e",
      bgColor: "#ff091105",
    },
    {
      status: ["GettingPlace", "ToPlace"],
      label: "กำลังดำเนินการ",
      color: "#FF9800",
      hoverColor: "#de8500",
      bgColor: "#ffb60005",
    },
  ];

  useEffect(() => {
    const formatDate = (date) => dayjs(date).format("D MMM YYYY");
    const formatTime = (time) => dayjs(time).format("HH.mm") + " น.";

    let listBooking = props.booking;
    if (listBooking != null) {
      const listA = [];
      const listB = [];
      const listC = [];

      listBooking.forEach((booking) => {
        const formattedBooking = {
          bookingId: booking.idBetweenSiteCar,
          nameLabel: "ผู้จอง ",
          name: `${booking.firstnameEmployee} ${booking.lastnameEmployee}`,
          email: booking.emailEmployee || "-",
          phone: booking.phoneRequester
            ? booking.phoneRequester
            : booking.phoneEmployee
            ? booking.phoneEmployee
            : null,
          startDateLabel: `${
            props.showHistory === 1
              ? "วัน-เวลา ที่ส่งผู้โดยสาร "
              : props.betweenSiteStatus === "กำลังดำเนินการ"
              ? "วัน-เวลา ที่รับผู้โดยสาร "
              : "วัน-เวลา ที่จอง "
          }`,
          startDate: `${
            props.showHistory === 1
              ? formatDate(booking.dropoffTime)
              : props.betweenSiteStatus === "กำลังดำเนินการ"
              ? booking.pickupTime
                ? formatDate(booking.pickupTime)
                : "รอไปรับ"
              : formatDate(booking.date)
          }`,
          startTime: `${
            props.showHistory === 1
              ? formatTime(booking.dropoffTime)
              : props.betweenSiteStatus === "กำลังดำเนินการ"
              ? booking.pickupTime
                ? formatTime(booking.pickupTime)
                : ""
              : formatTime(booking.date)
          }`,
          fromPlace: booking.fromPlace,
          toPlace: booking.toPlace,
          status: booking.isFinish
            ? // Already Finish (Done / Cancel)
              booking.targetStatus === "Cancel"
              ? "ยกเลิกรายการ"
              : "รายการเสร็จสิ้น"
            : // Not Finish Yet (Waiting Driver to Accept / Driver Accepted Booking)
            booking.targetStatus === "Waiting"
            ? "รอการจัดหาคนขับรถ"
            : "กำลังดำเนินการ",
        };

        if (booking.isFinish) {
          if (booking.targetStatus !== "Cancel") {
            listA.push(formattedBooking);
          }
        } else {
          if (booking.targetStatus === "Waiting") {
            listC.push(formattedBooking);
          } else {
            listB.push(formattedBooking);
          }
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
      setListBookingWaitingForDriver(listC);
    }
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          paddingBlock: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
            flex: 1,
          }}
        >
          <div
            style={{
              minWidth: "100%",
              display: "flex",
              gap: "12px",
              overflowX: "auto",
              flexWrap: "wrap",
            }}
          >
            {props.showHistory !== 1 &&
              statusOptions.map(
                ({ status, label, color, hoverColor, bgColor }) => (
                  <ButtonBlue
                    key={label}
                    variant={
                      props.betweenSiteStatus === label
                        ? "contained"
                        : "outlined"
                    }
                    customColor={color}
                    sx={
                      props.betweenSiteStatus === label
                        ? {
                            "&:hover": {
                              borderColor: hoverColor,
                              backgroundColor: hoverColor,
                            },
                          }
                        : {
                            "&:hover": {
                              backgroundColor: bgColor,
                              borderColor: hoverColor,
                            },
                          }
                    }
                    onClick={() =>
                      props.handleStatusFilter(status, "BetweenSiteCar")
                    }
                  >
                    {label}
                  </ButtonBlue>
                )
              )}
          </div>
        </div>
      </div>
      {(listBookingIsSuccess ||
        listBookingNotSuccess ||
        listBookingWaitingForDriver) && (
        <HeaderFooter
          columns={
            props.showHistory === 1
              ? columnsByStatus["รายการเสร็จสิ้น"]
              : columnsByStatus[props.betweenSiteStatus]
          }
          listBookingIsSuccess={listBookingIsSuccess}
          listBookingNotSuccess={
            props.betweenSiteStatus === "กำลังดำเนินการ"
              ? listBookingNotSuccess
              : listBookingWaitingForDriver
          }
          showHistory={props.showHistory}
          typeOfBooking={props.typeOfBooking}
          onClickCardHandler={props.onClickCardHandler}
        />
      )}
    </div>
  );
};

export default BetweenSiteCar;
